// extracted by mini-css-extract-plugin
export default {"b_pa_adiv":"Btnpalette_b_pa_adiv__4B3lc","b_pa_img":"Btnpalette_b_pa_img__vEL4B","palettedown":"Btnpalette_palettedown__Y8gZV"};